import { createRoot } from 'react-dom/client';
import 'assets/global-styles.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'store';
import { theme } from 'constants/styled-theme';
import { ThemeProvider } from 'styled-components';
import { Suspense } from 'react';
import { history } from 'history-setup';
import { ToastrManagerComponent } from 'components/common/toastr';
import Routes from './routes';
import { HeaderBar } from './components/header-bar';
import { MobileHeader } from './components/header-bar/mobile';
import { GlobalStyle } from './global-style';

window.addEventListener('scroll', () => {
  const filtersBar = document.getElementById('filterBar');
  const isPageScrolled = +window.pageYOffset > 260 || +document.documentElement.scrollTop > 260;
  if (!isPageScrolled && filtersBar) {
    filtersBar.classList.remove('scrolled');
    return;
  }
  if (filtersBar) {
    filtersBar.classList.add('scrolled');
  }
});
const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter history={history}>
        <GlobalStyle />
        <HeaderBar />
        <MobileHeader />
        <ToastrManagerComponent />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes />
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);
